import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { format } from "date-fns";
import { baseUrl, Fetch } from "../../shared/Fetch";

interface IPaperWork {
    document_Type?: string,
    document_ID?: number,
    pO_ID?: number,
    consultant_ID?: number,//Consultant
    sub_Vendor_ID?: number,//Vendor
    prime_Vendor_ID?: number,//Client
    document_Name?: string,
    expiration_Date?: Date | string,
    document_Path?: string,
    addedBy?: number,
    addedByName?: string,
    editedBy?: number,
    editedByName?: string,
    document_Status?: string,
    addedOn?: Date
}

interface IProps {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    pO_ID: number,
    consultant_ID: number,
    sub_Vendor_ID: number,
}

export const DocumentList = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [documentsList, setDocumentsList] = useState<{
        consultant_documents: Array<IPaperWork>,
        vendor_documents: Array<IPaperWork>,
    }>({ consultant_documents: [], vendor_documents: [] });

    const loadDocumentsList = async () => {
        setLoading(true);
        const response = await Fetch("vwPODetails/apw", "GET", null, `po_id=${props.pO_ID}`, props.toast);
        if (response) {
            const data: {
                consultant_documents: Array<IPaperWork>,
                vendor_documents: Array<IPaperWork>,
                client_documents: Array<IPaperWork>,
            } = await response.json();
            setDocumentsList(data);
            setLoading(false);
        } else setLoading(false);
    }

    const downloadDocument = async (data: IPaperWork) => {
        data.pO_ID = props.pO_ID;
        data.consultant_ID = props.consultant_ID;
        data.sub_Vendor_ID = props.sub_Vendor_ID;
        data.prime_Vendor_ID = 0;
        const params = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: JSON.stringify(data)
        };
        try {
            const response = await fetch(`${baseUrl}${"vwPODetails/document"}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = data.document_Path ? data.document_Path : "document";
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    function onHide() {
        setDocumentsList({ consultant_documents: [], vendor_documents: [] });
        props.hideDialog();
    };

    const expiration_Date = (rowData: IPaperWork) => {
        let date;
        if (rowData.expiration_Date) date = format(new Date(rowData.expiration_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const file = (rowData: IPaperWork) => {
        return (<span onClick={() => downloadDocument({ ...rowData })} className="cursor-pointer text-cyan-700 underline">Download</span>);
    };

    const document_Status = (rowData: IPaperWork) => {
        return (
            rowData.document_Name === "1099" ||
            rowData.document_Name === "W2" ||
            rowData.document_Name === "W4" ||
            rowData.document_Name === "SSN" ||
            rowData.document_Name === "Vendor VOID CHECK" || rowData.document_Name === "Vendor ACH"
        ) ? "" : (
            <span className="cursor-pointer text-cyan-700 ">{rowData.document_Status}</span>
        );
    };

    useEffect(() => {
        if (props.open) loadDocumentsList();
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Consultant/Vendor Documents" className="p-fluid" onHide={onHide}>
            {props.consultant_ID !== 0 && <DataTable className="mt-2" style={{ border: '1px solid #696969', borderTopWidth: "0" }}
                size="small" value={documentsList.consultant_documents} header="Consultant Document List" showGridlines stripedRows loading={loading}
            >
                <Column field="document_Name" header="Document Name" />
                <Column field="expiration_Date" header="Expiration Date" body={expiration_Date} />
                <Column field="file" header="File" body={file} />
                <Column field="addedByName" header="Added By" />
                <Column field="editedByName" header="Edited By" />
                <Column field="document_Status" header="Status" body={document_Status} />
            </DataTable>}
            {props.sub_Vendor_ID !== 0 && <DataTable className="mt-2" style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                size="small" value={documentsList.vendor_documents} header="Vendor Document List" showGridlines stripedRows loading={loading}
            >
                <Column field="document_Name" header="Document Name" />
                <Column field="expiration_Date" header="Expiration Date" body={expiration_Date} />
                <Column field="file" header="File" body={file} />
                <Column field="addedByName" header="Added By" />
                <Column field="editedByName" header="Edited By" />
                <Column field="document_Status" header="Status" body={document_Status} />
            </DataTable>}
        </Dialog>
    );
}